var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskicon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FFEDD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.4C19.0667 29.4 18.2778 29.11 17.6333 28.53C16.9889 27.95 16.6667 27.24 16.6667 26.4C16.6667 25.56 16.9889 24.85 17.6333 24.27C18.2778 23.69 19.0667 23.4 20 23.4C20.9333 23.4 21.7222 23.69 22.3667 24.27C23.0111 24.85 23.3333 25.56 23.3333 26.4C23.3333 27.24 23.0111 27.95 22.3667 28.53C21.7222 29.11 20.9333 29.4 20 29.4ZM14.6667 36C13.9333 36 13.3056 35.765 12.7833 35.295C12.2611 34.825 12 34.26 12 33.6V16.8C12 16.14 12.2611 15.575 12.7833 15.105C13.3056 14.635 13.9333 14.4 14.6667 14.4H16V12H18.6667V14.4H29.3333V12H32V14.4H33.3333C34.0667 14.4 34.6944 14.635 35.2167 15.105C35.7389 15.575 36 16.14 36 16.8V33.6C36 34.26 35.7389 34.825 35.2167 35.295C34.6944 35.765 34.0667 36 33.3333 36H14.6667ZM14.6667 33.6H33.3333V21.6H14.6667V33.6ZM14.6667 19.2H33.3333V16.8H14.6667V19.2Z",
    fill: "#EA580C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskicon6);
export default __webpack_public_path__ + "static/media/taskicon6.45e89540b85963b412c08fba60705553.svg";
export { ForwardRef as ReactComponent };